module.exports = __webpack_public_path__ + "static/media/cover.1313b7ec.png";